var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavaScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 30C6.25 18.8041 6.25 13.2062 9.72811 9.72811C13.2062 6.25 18.8041 6.25 30 6.25C41.1959 6.25 46.7938 6.25 50.2719 9.72811C53.75 13.2062 53.75 18.8041 53.75 30C53.75 41.1959 53.75 46.7938 50.2719 50.2719C46.7938 53.75 41.1959 53.75 30 53.75C18.8041 53.75 13.2062 53.75 9.72811 50.2719C6.25 46.7938 6.25 41.1959 6.25 30Z",
    stroke: "#25282B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3311 30V40C29.3311 42.7614 27.0925 45 24.3311 45C22.4804 45 20.8645 43.9945 20 42.5",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.167 32.5C45.3025 31.0055 43.6866 30 41.8359 30H40.5859C38.5149 30 36.8359 31.6789 36.8359 33.75C36.8359 35.8211 38.5149 37.5 40.5859 37.5H43.0859C45.157 37.5 46.8359 39.1789 46.8359 41.25C46.8359 43.3211 45.157 45 43.0859 45H41.8359C39.9852 45 38.3694 43.9945 37.5048 42.5",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScript);
export default __webpack_public_path__ + "static/media/java-script.a480b8ecaac0f9e416c7c92251421329.svg";
export { ForwardRef as ReactComponent };